import { render, staticRenderFns } from "./WatcherModal.vue?vue&type=template&id=0f1f99ce&"
import script from "./WatcherModal.vue?vue&type=script&lang=ts&"
export * from "./WatcherModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports